/**
 * 通用js方法封装处理
 * Copyright (c) 2021 ruoyi
 */
export const fliters = {
    /**
     * 时间格式转换过滤器
     */
    timefilters(val) {
        if (val == null || val == "") {
            return "-";
        } else {
            let d = new Date(val);   //val 为表格内取到的后台时间
            let month =
                d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
            let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
        }
    },
    formatSeconds(value) {
        //  秒
        let second = parseInt(value)
        //  分
        let minute = 0
        //  小时
        let hour = 0
        //  天
        //  let day = 0
        //  如果秒数大于60，将秒数转换成整数
        if (second > 60) {
            //  获取分钟，除以60取整数，得到整数分钟
            minute = parseInt(second / 60)
            //  获取秒数，秒数取佘，得到整数秒数
            second = parseInt(second % 60)
            //  如果分钟大于60，将分钟转换成小时
            if (minute > 60) {
                //  获取小时，获取分钟除以60，得到整数小时
                hour = parseInt(minute / 60)
                //  获取小时后取佘的分，获取分钟除以60取佘的分
                minute = parseInt(minute % 60)
            }
        }

        let result = '' + parseInt(second) + '秒'
        if (minute > 0) {
            result = '' + parseInt(minute) + '分' + result
        }
        if (hour > 0) {
            result = '' + parseInt(hour) + '小时' + result
        }
        return result
    },
    
}
